import { useGetLicences, useGetPayments } from "@/features/applications/repositories/licences-repository"
import ApplicationTile from "./fragments/application-tile"
import NotificationsPanel from "./fragments/notifications-panel"
import PaymentTile from "./fragments/payment-tile"
import TopBanner from "./fragments/top-banner"
import { Link } from "react-router-dom"


const Dashboard = () => {
    const { licences, isLoading } = useGetLicences({
        pager: { page: 1, size: 3 }
    });

    const { payments, isLoading: isLoadingPayments } = useGetPayments({
        pager: { page: 1, size: 3 }
    });
    console.log(payments,"Hapa ")
    return (
        <div className="bg-[#fcfaf8] px-4">
            <div className="flex justify-between  w-full gap-3 ">
                <div className="flex flex-col gap-3">
                    <div>
                        <TopBanner />
                    </div>
                    <div className="bg-white shadow-sm rounded-lg p-5 md:h-[300px]">
                        <div className="flex justify-between items-center ">
                            <div>
                                <h1 className="text-lg font-bold">Applications</h1>
                            </div>
                            <div>
                                <Link to={"/applications/licences"}>
                                    <span className="text-sm text-primary underline">See All Applications  </span>
                                </Link>
                            </div>
                        </div>
                        {
                            isLoading ? (
                                <div className="flex justify-center items-center h-full">
                                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
                                </div>
                            ): (
                                licences?.results.map((licence:any) => (
                                    <ApplicationTile
                                        id={licence.id}
                                        key={licence.id}
                                        applicationStatus={licence.applicationStatus}
                                        applicationDate={licence.dateIssues}
                                        applicationRegion={licence.region}
                                        applicationZone={licence.zone}
                                    />
                                ))
                            )
                        }
              
                    </div>
                    <div className="bg-white shadow-sm rounded-lg p-5 md:h-[300px]">
                        <div className="flex justify-between items-center ">
                            <div>
                                <h1 className="text-lg font-bold">Payments</h1>
                            </div>
                        </div>
                        {
                            isLoadingPayments ? (
                                <div className="flex justify-center items-center h-full">
                                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary"></div>
                                </div>
                            ): (
                                payments?.results.map((payment:any) => (
                                    <PaymentTile
                                        key={payment.id}
                                        paymentMethod={payment.paymentMethod}
                                        amount={payment.amount}
                                        currency={payment.currency}
                                        createdAt={payment.createdAt}
                                        transactionReference={payment.transactionReference}
                                        status={payment.status}
                                    />
                                ))
                            )
                        }
                    </div>
                </div>
                <NotificationsPanel />
            </div>
        </div>
    )
}

export default Dashboard